import en from './en';
import common from './en-US/pages/common';
import subscription from './en-US/pages/subscription';
import budget from './en-US/pages/budget';

export default {
    ...en,
    common,
    subscription,
    budget,
    // We need to re-export the spread 'en' properties that are overridden
    // so that the deep merge or simple object spread works as expected.
    // In the 'en.ts' file, 'common' and 'subscription' are top-level keys.
};
